// wipe-line.js — shared "wipe-through" hover underline.
//
// Add class="wipe-line" to a button/link that contains a .wipe-line__line element. On hover the bar
// wipes IN from the left; on leave it continues OUT to the right (not back the way it came), then
// resets instantly off-screen. Mirrors the SIIYS size buttons + region-widget, extracted so the
// behaviour isn't copied a third time. State is three classes toggled here: is-line-in / is-line-out.
//
// Idempotent; arms current AND future .wipe-line elements (e.g. modal-cloned triggers) via a
// MutationObserver — same shape as assets/media-fade.js.
(function () {
  function arm(el) {
    if (el.__wipeArmed) return;
    el.__wipeArmed = true;

    el.addEventListener('mouseenter', function () {
      el.classList.remove('is-line-out');
      el.classList.add('is-line-in');
    });

    el.addEventListener('mouseleave', function () {
      if (!el.classList.contains('is-line-in')) return;
      el.classList.remove('is-line-in');
      el.classList.add('is-line-out');
    });

    // When the out-sweep finishes, drop the class so the bar snaps back off-left (no transition on
    // the base rule = instant reset, ready for the next hover). Guard on `transform` so an unrelated
    // transition on the element can't cut the sweep short.
    el.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      if (el.classList.contains('is-line-out')) el.classList.remove('is-line-out');
    });
  }

  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches('.wipe-line')) arm(root);
    if (root.querySelectorAll) root.querySelectorAll('.wipe-line').forEach(arm);
  }

  scan(document);

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) scan(added[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
